var _a;
import { OrderResourceType } from '@returnmates/client-core/src/graphql/generated/api';
export var PARTNER_RESOURCE_MAP = (_a = {},
    _a[OrderResourceType.RETURNMATES] = 'Returnmates',
    _a[OrderResourceType.NARVAR] = 'Narvar',
    _a);
//# sourceMappingURL=partner.js.map